import { UserAgentApplication } from 'msal';

const clientId = process.env.NODE_ENV === 'development' ? process.env.AZURE_CLIENTID_LOCAL : process.env.AZURE_CLIENTID_DEV;
const tenantId = process.env.AZURE_TENANT;
const redirectUri = process.env.NODE_ENV === 'development' ? window.location.origin : window.location.origin + '/portal';

const config = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri
  }
};

const tokenConfig = {
  scopes: ['User.Read']
};

export const auth = new UserAgentApplication(config);

auth.handleRedirectCallback(error => {
  if (error) {
    console.error(error);
  }
});

export const getToken = () =>
  auth
    .acquireTokenSilent(tokenConfig)
    .catch(() => auth.acquireTokenRedirect(tokenConfig))
    .then(({ idToken }) => idToken.rawIdToken);



// WEBPACK FOOTER //
// ./src/SSO/config/auth.js